import React from 'react';
import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext/AuthContext';

interface PrivateRouteProps {
  roles?: string[];
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ roles }) => {
  const { user, isTokensLoading } = useAuth();
  const { t } = useTranslation('components');
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (isTokensLoading) {
    return <div>{t('privateRoute.loading')}</div>;
  }

  if (!user) {
    // The partner links point to /buy-funded: an anonymous visitor goes to the application
    // funnel with the whole query string (affiliate code, campaign tags, capital).
    if (location.pathname === '/buy-funded') {
      return <Navigate to={{ pathname: '/apply', search: location.search }} />;
    }
    const affiliate = searchParams.get('affiliate');
    if (affiliate) {
      return <Navigate to={{ pathname: '/apply', search: location.search }} />;
    }
    return <Navigate to="/login" />;
  }

  // Si l'utilisateur est connecté mais que son rôle ne correspond pas
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/unauthorized" />;
  }

  // Si tout est OK, on affiche le contenu de la route privée
  return <Outlet />;
};
